<template>
  <div v-if="showNotice">
    <div class="main" :class="{ focused: isFocusedView }">
      <div @mouseover="focusIndex = -1" @click="enterKeyProc">
        <img
          v-if="focusIndex === -1"
          class="return_ic"
          src="@/assets/return-detail-f-ic.png"
        />
        <img v-else class="return_ic" src="@/assets/return-detail-ic.png" />
      </div>
      <p class="title">점검공지</p>
      <p class="notice-title">{{ noticeData.title }}</p>
      <div class="text-box">
        <textarea
          readonly
          class="text-area"
          v-model="noticeData.content"
          disabled="disabled"
          ref="textBox"
        ></textarea>
        <button
          class="scroll-up"
          :class="{ focused: focusIndex === 0 }"
          @click="enterKeyProc"
          @mouseover="focusIndex = 0"
        >
          <img src="@/assets/scroll-up-ic-u.png" class="img-u" />
          <img src="@/assets/scroll-up-ic-f.png" class="img-f" />
        </button>
        <button
          class="scroll-down"
          :class="{ focused: focusIndex === 1 }"
          @click="enterKeyProc"
          @mouseover="focusIndex = 1"
        >
          <img src="@/assets/scroll-down-ic-u.png" class="img-u" />
          <img src="@/assets/scroll-down-ic-f.png" class="img-f" />
        </button>
      </div>
      <button
        class="exit-botton"
        :class="{ focused: focusIndex === 2 }"
        @click="enterKeyProc"
        @mouseover="focusIndex = 2"
        ref="exit"
      >
        확인
      </button>
    </div>
  </div>
</template>

<script>
import { autoLogin, lgDeepLinkCheck } from "@/utils/common"

export default {
  data() {
    return {
      isActiveVue: true,
      focusIndex: 2,
      maxIndex: 2,
      scrollRange: 428,
      showNotice: false,
      noticeData: {},
    };
  },
  computed: {
    keyInput() {
      return this.$store.getters.keyInput;
    },
    fousedView() {
      return this.$store.getters.focusedView;
    },
    // noticeData() {
    //   return this.$store.getters.systemPopup;
    // },
    isFocusedView() {
      return this.fousedView === "default";
    },
    deviceId() {
      return this.$store.getters.deviceId;
    },
  },

  watch: {
    keyInput(val, oldVal) {
      if (this.isActiveVue && val.focusView == "default") {
        switch (val.key) {
          case "ArrowUp":
            this.upKeyProc(val);
            break;
          case "ArrowDown":
            this.downKeyProc(val);
            break;
          case "Enter":
            this.enterKeyProc(val);
            break;
          case "Backspace":
            this.backKeyProc(val);
            break;
        }
      }
    },
  },

  methods: {
    isFocusedMenu(index) {
      return index == this.focusedIndex;
    },
    upKeyProc(keyInput) {
      if (this.focusIndex > -1) {
        --this.focusIndex;
      }
    },
    downKeyProc(keyInput) {
      if (this.focusIndex < this.maxIndex) {
        ++this.focusIndex;
      }
    },
    enterKeyProc(keyInput) {
      switch (this.focusIndex) {
        case -1:
          this.backKeyProc();
          break;
        case 0:
          this.scrollUp();
          break;
        case 1:
          this.scrollDown();
          break;
        case 2:
          this.backKeyProc();
          break;
      }
    },
    backKeyProc(keyInput) {
      this.checkLogin();
    },
    scrollUp() {
      let scrollPosition = this.$refs.textBox.scrollTop - this.scrollRange;
      if (scrollPosition < 0) {
        scrollPosition = 0;
      }
      this.$refs.textBox.scrollTop = scrollPosition;
    },
    scrollDown() {
      let scrollPosition = this.$refs.textBox.scrollTop + this.scrollRange;
      if (scrollPosition < this.$refs.textBox.scrollHeight) {
        this.$refs.textBox.scrollTop = scrollPosition;
      }
    },
    checkLogin() {
      autoLogin(this.goToHome)
    },
    goToHome() {
      this.$progress.$emit("off:progress");

      if (process.env.VUE_APP_OS_TYPE == "samsung") {
        this.$router.replace({
          name: "home",
          params: {
            t: new Date().getTime(),
          },
        });
      } else {       
        // LG DeepLink를 통해 앱 실행 시 해당 영상으로 이동 처리  
        lgDeepLinkCheck()
      }
    },
    goToLogin() {
      this.$progress.$emit("off:progress");

      this.$router.replace({
        name: "login",
        params: {
          t: new Date().getTime(),
        },
      });
    },
  },
  created() {
    this.$progress.$emit("on:progress");

    this.$store
      .dispatch("FETCH_SYSTEM_POPUP")
      .then((response) => {
        this.$progress.$emit("off:progress");
  
        if (response.data.length < 1) {
          this.checkLogin();
        } else {
          for (let i in response.data) {
            if (response.data[i].kind == 2) {
              this.noticeData = response.data[i];
              this.showNotice = true;
              return;
            }
          }
          this.checkLogin();
        }
      }).catch(err => {
        this.checkLogin();
      })
  },
  mounted() {
    if(Number(window.innerWidth) <= 1280) this.scrollRange = 200
  },
  activated() {
    this.isActiveVue = true;
  },
  deactivated() {
    this.isActiveVue = false;
  },
};
</script>

<style scoped >
.main {
  left: 96px;
  top: 54px;
}
.return_ic {
  width: 72px;
  height: 72px;
  left: 0;
  top: 0;
}
.title {
  font-size: 56px;
  color: #eeeeee;
  margin-top: 67px;
}
.notice-title {
  font-size: 28px;
  color: #888888;
  margin-top: 30px;
}
.text-box {
  width: 1728px;
  height: 476px;
  margin-top: 15px;
  margin-bottom: 40px;
  background-color: #191919;
}
button {
  border: none;
}
.focused .exit-botton.focused {
  border: solid 4px #eeeeee;
}
button img {
  position: absolute;
  left: 0;
  top: 0;
}
textarea {
  width: 1600px;
  height: 448px;
  margin: 14px 30px;
  color: #888888;
  background-color: #191919;
  font-size: 24px;
  line-height: 1.5;
  overflow: auto;
  border: none;
  resize: none;
  padding-right: 56px;
}

::-webkit-scrollbar-thumb {
  height: 48px;
  background-color: #3e3e3e;
  border-radius: 0;
  /* width : 16px; */
}
::-webkit-scrollbar {
  width: 16px;
}
::-webkit-scrollbar-track {
  margin: 105px 0;
}

.scroll-up {
  position: absolute;
  top: 20px;
  right: 83px;
}
.scroll-down {
  position: absolute;
  bottom: 83px;
  right: 83px;
}
.img-f {
  display: none;
}
button.focused .img-u {
  display: none;
}
button.focused .img-f {
  display: block;
}
.exit-botton {
  width: 1728px;
  height: 80px;
  margin: 0 24px 0 0;
  background-color: #3e3e3e;
  font-size: 28px;
  text-align: center;
  color: #eeeeee;
  border: none;
}

@media all and (min-width:0px) and (max-width:1280px){
  .main {
    left: 80px;
    top: 54px;
  } 
  .return_ic {
    width: 48px;
    height: 48px;
    left: 0;
    top: 0;
  }
  .title {
    font-size: 40px;
    color: #ffffff;
    margin-top: 40px;
  }
  .notice-title {
    font-size: 18px;
    color: #888888;
    margin-top: 20px;
  }
  .text-box {
    width: 1120px;
    height: 352px;
    margin-top: 16px;
    margin-bottom: 40px;
    background-color: #222222;
    overflow: hidden;
    padding: 16px;
  }
  textarea {
    width: 1076px; 
    height: 100%;
    margin: 0;
    color: #888888;
    background-color: #222222;
    font-size: 16px;
    line-height: 1.5;
    overflow: auto;
    border: none;
    resize: none;
    padding-right: 32px;
  }
  
  ::-webkit-scrollbar {
    width: 8px;
  }
  ::-webkit-scrollbar-thumb {
    height: 40px;
    background-color: #979797;
    border-radius: 0;
  }
  ::-webkit-scrollbar-track {
    margin: 52px 0;
    background-color: #3e3e3e;
  }

  .exit-botton {
    width: 1120px;
    height: 56px;
    margin: 0 24px 0 0;
    background-color: #3e3e3e;
    font-size: 28px;
    text-align: center;
    color: #eeeeee;
    border: none;
  }
  .focused .exit-botton.focused {
    border: solid 3px #eeeeee;
  }

  .scroll-up {
    position: absolute;
    top: 12px;
    right: 52px;
  }
  .scroll-down {
    position: absolute;
    bottom: 52px;
    right: 52px;
  }

  .img-f {
    width: 40px;
    height: 40px;
  }

  .img-u {
    width: 40px;
    height: 40px;
  }
}
</style>